export default function($) {
  $(document).ready(function() {
    // The js-menu-item-products and js-menu-item-brands classes have to be set in back-office Apparence > Menus in Primary Menu "Produits" and "Marques" elements
    var productsMenu = $('.js-menu-item-products'),
        productsMenuContent = $('.js-megamenu-products'),
        brandsMenu = $('.js-menu-item-brands'),
        brandsMenuContent = $('.js-megamenu-brands');

    productsMenu.hover(function () {
      productsMenuContent.addClass('open');
    }, function(){
      if( ! productsMenuContent.is(":hover") ) {
        productsMenuContent.removeClass('open');
      }
    });
    productsMenuContent.hover(function () {
      productsMenuContent.addClass('open');
    }, function(){
      if( ! productsMenu.is(":hover") ) {
        productsMenuContent.removeClass('open');
      }
    });

    brandsMenu.hover(function () {
      brandsMenuContent.addClass('open');
    }, function(){
      if( ! brandsMenuContent.is(":hover") ) {
        brandsMenuContent.removeClass('open');
      }
    });
    brandsMenuContent.hover(function () {
      brandsMenuContent.addClass('open');
    }, function(){
      if( ! brandsMenu.is(":hover") ) {
        brandsMenuContent.removeClass('open');
      }
    });


    // Megamenu always display on pages
    var archiveImageUrlDefault = $('.js-megamenu__archive-image').attr('data-archive-image-url-default');

    $('.js-megamenu__archive-link').each(function() {
      $(this).on('mouseover', function() {
        var archiveImageUrl = $(this).attr('data-archive-image-url');
        $(this).parents('.megamenu').find('.js-megamenu__archive-image').attr('src', archiveImageUrl);
      });
    });

    $('.js-megamenu__list').on('mouseleave', function() {
      $(this).parents('.megamenu').find('.js-megamenu__archive-image').attr('src', archiveImageUrlDefault);
    })

    // Subcategories

    $('.js-megamenu-subcategory').each(function() {
      if( $(this).siblings('.js-megamenu-subcategory__content').find('.megamenu-subsubcategory').hasClass('megamenu-subsubcategory-current') ) {
        $(this).addClass('open');
        $(this).siblings('.js-megamenu-subcategory__content').find('.megamenu-subsubcategory').slideDown('fast');
      }
      $(this).on('click', function(e) {
        if( ! $(this).hasClass('open') ) {
          e.preventDefault();
          $('.js-megamenu-subcategory').removeClass('open');
          $('.megamenu-subsubcategory').slideUp('fast');
          $(this).addClass('open');
          $(this).siblings('.js-megamenu-subcategory__content').find('.megamenu-subsubcategory').slideDown('fast');
        }
      })
    })
  });
}
